import { call, put, takeLatest, all } from "redux-saga/effects";
import { apiQueryWithToken } from "../../../common/services/apiBaseUrlConfig";
import { ENDPOINT } from "../../../common/services/endpoint.config";
import {
  getDeploymentDetailsData,
  getDeploymentDetailsDataSuccess,
  getDeploymentDetailsDataFailure,
  addDeploymentScheduleData,
  addDeploymentScheduleDataSuccess,
  addDeploymentScheduleDataFailure,
  updateDeploymentScheduleData,
  updateDeploymentScheduleDataSuccess,
  updateDeploymentScheduleDataFailure,
  deleteDeploymentScheduleData,
  deleteDeploymentScheduleDataSuccess,
  deleteDeploymentScheduleDataFailure,
} from "./deploymentSchedulerSlice";

function* getDeploymentDetails() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_DETAILS)
    );
    const responseData = response.data;
    yield put(getDeploymentDetailsDataSuccess(responseData));
  } catch (error) {
    yield put(getDeploymentDetailsDataFailure(error.message));
  }
}

function* addDeploymentSchedule(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(
        ENDPOINT.ADD_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_SCHEDULE,
        action.payload
      )
    );
    const responseData = response.data;
    yield put(addDeploymentScheduleDataSuccess(responseData));
    yield put(getDeploymentDetailsData());
  } catch (error) {
    yield put(addDeploymentScheduleDataFailure(error.message));
  }
}

function* updateDeploymentSchedule(action) {
  try {
    const { id, payload } = action.payload || {};
    const endpoint = String(
      ENDPOINT.UPDATE_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_SCHEDULE || ""
    ).replace("{id}", String(id));
    const response = yield call(() => apiQueryWithToken.put(endpoint, payload));
    const responseData = response.data;
    yield put(updateDeploymentScheduleDataSuccess(responseData));
    yield put(getDeploymentDetailsData());
  } catch (error) {
    yield put(updateDeploymentScheduleDataFailure(error.message));
  }
}

function* watchDeploymentDetails() {
  yield takeLatest(getDeploymentDetailsData.type, getDeploymentDetails);
}

function* watchAddDeploymentSchedule() {
  yield takeLatest(addDeploymentScheduleData.type, addDeploymentSchedule);
}

function* watchUpdateDeploymentSchedule() {
  yield takeLatest(updateDeploymentScheduleData.type, updateDeploymentSchedule);
}

function* deleteDeploymentSchedule(action) {
  try {
    const id = action.payload;
    const endpoint = String(
      ENDPOINT.UPDATE_ADMIN_PLANNED_OUTAGE_DEPLOYMENT_SCHEDULE || ""
    ).replace("{id}", String(id));
    const response = yield call(() => apiQueryWithToken.delete(endpoint));
    const responseData = response.data;
    yield put(deleteDeploymentScheduleDataSuccess(responseData));
    yield put(getDeploymentDetailsData());
  } catch (error) {
    yield put(deleteDeploymentScheduleDataFailure(error.message));
  }
}

function* watchDeleteDeploymentSchedule() {
  yield takeLatest(deleteDeploymentScheduleData.type, deleteDeploymentSchedule);
}

export default function* deploymentSchedulerSaga() {
  yield all([
    watchDeploymentDetails(),
    watchAddDeploymentSchedule(),
    watchUpdateDeploymentSchedule(),
    watchDeleteDeploymentSchedule(),
  ]);
}

export {
  getDeploymentDetails,
  addDeploymentSchedule,
  updateDeploymentSchedule,
  deleteDeploymentSchedule,
  watchDeploymentDetails,
  watchAddDeploymentSchedule,
  watchUpdateDeploymentSchedule,
  watchDeleteDeploymentSchedule,
};
